import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { utils } from "../../Helpers";
import {
  Ban,
  CircleCheck,
  CircleCheckBig,
  CircleX,
  Handshake,
  Info,
  MessageCircleMore,
  MessageSquareDiff,
  MessageSquareText,
  StickyNote,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@radix-ui/react-dropdown-menu";
import ModelCommon from "../../Components/ModelCommon";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { offerService } from "../../Services";
import { decodeFromBase64 } from "../../Components/Constants/AppConstant";
import { Tooltip } from "@mui/material";
import OfferDetails from "../Offer/OfferDetails";

export default function InfluencerOfferItem(props) {
  const isReuqstedBy = props.user.data.id === props.cancel_requested_by;

  const [modalApplicationData, setModalApplicationData] = useState(null);
  const [applicationId, setApplicationId] = useState(null);
  const [modal, setModal] = useState(null);
  const [applicaitonData] = useState(props);

  function capitalizeFirstLetter(val) {
    return String(val)?.charAt(0)?.toUpperCase() + String(val)?.slice(1);
  }
  const navigate = useNavigate();
  function goToReview() {
    navigate("/influencer/review");
  }
  const startchat = (id, userId, username) => {
    props.onStartChat({ offerId: id, userId: { value: username, id: 2 } });
    navigate("/influencer/chat");
  };

  const getPlatformIcon = (platformCode) => {
    const id = platformCode?.toString();

    switch (id) {
      case "IG":
        return (
          <img
            src="/images/instagram.svg"
            alt="Instagram"
            width="24"
            height="24"
          />
        );
      case "TT":
        return (
          <img
            src="/images/tiktok-logo.svg"
            alt="TikTok"
            width="24"
            height="24"
          />
        );
      case "FB":
        return (
          <img
            src="/images/facebook.svg"
            alt="Facebook"
            width="24"
            height="24"
          />
        );
      case "YT":
        return (
          <img src="/images/youtube.svg" alt="YouTube" width="24" height="24" />
        );
      default:
        return <span>{platformCode || "NA"}</span>;
    }
  };

  const handleApplicationDetails = (id) => {
    setModalApplicationData("detail");
    setApplicationId(id);
  };

  const handleOfferAction = async (action, closeModal = false) => {
    try {
      const res = await offerService.setOfferActions(props.id, action);
      props.reFetchData();
      console.log(`🚀 ~ ${action} ~ res:`, res);
    } catch (err) {
      let errorMessage = `Failed to ${action} offer.`;
      if (err.response?.data) {
        const decodedError = decodeFromBase64(err.response.data);
        errorMessage = decodedError.message || errorMessage;
      } else if (err.message) {
        errorMessage = err.message;
      }
      console.log(errorMessage);
    }
    if (closeModal) setModal(null);
  };

  const handleAcceptOffer = () => handleOfferAction("accept", true);
  const handleRejectOffer = () => handleOfferAction("reject", true);
  const handleMarkAsread = () => handleOfferAction("complete");
  const handleCancelRequest = () => handleOfferAction("cancel");
  const handleEscalateToSupport = () => handleOfferAction("escalate", true);
  const handleAgreeCancelRequest = () =>
    handleOfferAction("cancel/approve", true);

  const statusRender = (status) => {
    const baseStyle =
      "inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium";

    switch (status) {
      case "pending":
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "accepted":
        return (
          <span className={`${baseStyle} bg-blue-100 text-blue-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "rejected":
        return (
          <span className={`${baseStyle} bg-red-100 text-red-700`}>
            {capitalizeFirstLetter(status)}
          </span>
        );

      case "complete":
        return (
          <span className={`${baseStyle} bg-green-100 text-green-700`}>
            Complete
          </span>
        );

      case "complete_pending":
        return (
          <Tooltip title="Waiting for the brand’s acceptance" arrow>
            <span
              className={`${baseStyle} bg-blue-100 text-blue-700`}
              title="Waiting for the brand’s acceptance"
            >
              <span>Complete</span>
              <Info size={16} />
            </span>
          </Tooltip>
        );
      case "cancel_requested":
        return (
          <span
            className={`${baseStyle} ${
              isReuqstedBy
                ? "bg-blue-100 text-blue-600"
                : "bg-yellow-100 text-yellow-600"
            } `}
            title="Waiting for the brand’s acceptance"
          >
            <span>{isReuqstedBy ? "Cancel Requested" : "Cancel Recieved"}</span>
          </span>
        );
      case "escalated":
        return (
          <span
            className={`${baseStyle} bg-red-100 text-red-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>Escalated</span>
          </span>
        );
      case "modification_requested":
        return (
          <span
            className={`${baseStyle} bg-yellow-100 text-yellow-600`}
            title="Waiting for the brand’s acceptance"
          >
            <span>Modification Requested</span>
          </span>
        );
      default:
        return (
          <span className={`${baseStyle} bg-gray-100 text-gray-600`}>
            {capitalizeFirstLetter(status)}
          </span>
        );
    }
  };

  const renderCellWithTooltip = (content, maxLength = 50) => {
    if (!content) return null;

    const truncated =
      content.length > maxLength
        ? `${content.substring(0, maxLength)}...`
        : content;

    return (
      // <Tooltip title={content} arrow placement="top">
      <span className="truncate">{truncated}</span>
      // </Tooltip>
    );
  };

  return (
    <>
      <tr>
        <td>
          {props.ds_campaign_application_id ? (
            <button onClick={() => handleApplicationDetails(props.id)}>
              <StickyNote color="#15803d" size={20} />
            </button>
          ) : (
            <button onClick={() => handleApplicationDetails(props.id)}>
              <Handshake color="#15803d" size={20} />
            </button>
          )}
        </td>
        <td className="!pl-2">
          <p>{utils.formatdate(props.created_at)}</p>
        </td>
        <td>
          <p className="flex gap-2 ">
            <img
              style={{ width: "28px", height: "28px", borderRadius: "50%" }}
              src={
                props.from_profile_img_url &&
                props.from_profile_img_url &&
                props.from_profile_img_url !== ""
                  ? props.from_profile_img_url
                  : `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`
              }
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = `${process.env.PUBLIC_URL}/images/placeholder/avatar.png`;
              }}
              alt="avatar"
            />
            <span className="mt-1">{props.from_displayname}</span>
          </p>
        </td>
        <td>
          <div className="flex gap-2 items-start whitespace-normal break-words ">
            {getPlatformIcon(props?.social_media_code)}
            <p className="text-sm text-gray-800 leading-snug break-words mt-0.5">
              {renderCellWithTooltip(props.description)}
            </p>
          </div>
        </td>
        <td>${props.price}</td>
        <td>{statusRender(props.status)}</td>
        <td>
          <div className="flex gap-0 items-center">
            <button
              className="button tertiary big"
              onClick={() => handleApplicationDetails(props.id)}
            >
              View
            </button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button
                  className="p-1 text-gray-600 hover:text-blue-600"
                  onClick={(e) => e.stopPropagation()}
                >
                  <MoreVertIcon />
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="end"
                className="w-[180px] border border-gray-200 bg-white p-2 rounded-lg shadow-lg mt-1 z-50"
              >
                <DropdownMenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    if (props.status === "complete") {
                      props.setOfferSelectedForReview(props.id);
                      goToReview();
                    } else {
                      startchat(props.id, props.to_user_id, props.username);
                    }
                  }}
                  className="cursor-pointer text-black font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1"
                >
                  {props.status === "complete" ? (
                    <>
                      {/* {addReview} */}
                      <MessageSquareDiff className="mr-2 h-4 w-4" /> Add Review
                    </>
                  ) : (
                    <>
                      {/* {chatIcon} */}
                      <MessageCircleMore className="mr-2 h-4 w-4" />
                      Chat
                    </>
                  )}
                </DropdownMenuItem>

                {props.status === "pending" && (
                  <>
                    <DropdownMenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        setModal("confirmAction");
                      }}
                      className="cursor-pointer hover:bg-green-50 font-semibold p-2 rounded-md flex gap-1 text-green-500"
                    >
                      <CircleCheckBig className="mr-2 h-4 w-4" />
                      Accept Offer
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        setModal("rejectAction");
                      }}
                      className="cursor-pointer font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1 text-red-500"
                    >
                      <CircleX className="mr-2 h-4 w-4" />
                      Reject Offer
                    </DropdownMenuItem>
                  </>
                )}
                {(props.status === "accepted" ||
                  props.status === "modification_requested") && (
                  <>
                    <DropdownMenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        handleMarkAsread();
                      }}
                      className="cursor-pointer text-green-500 font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1"
                    >
                      <MessageSquareText className="mr-2 h-4 w-4" />
                      Mark as Complete
                    </DropdownMenuItem>
                  </>
                )}

                {props.status === "accepted" ||
                props.status === "complete_pending" ? (
                  <DropdownMenuItem
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCancelRequest();
                    }}
                    className="cursor-pointer text-red-500 font-semibold hover:bg-green-50 p-2 rounded-md flex gap-1"
                  >
                    <Ban className="mr-2 h-4 w-4" />
                    Cancel Collab
                  </DropdownMenuItem>
                ) : null}

                {props.status === "cancel_requested" && !isReuqstedBy && (
                  <>
                    <DropdownMenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAgreeCancelRequest();
                      }}
                      className="cursor-pointer hover:bg-green-50 font-semibold p-2 rounded-md flex gap-1 text-green-500"
                    >
                      <CircleCheckBig className="mr-2 h-4 w-4" />
                      Agree Cancellation
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={(e) => {
                        e.stopPropagation();
                        handleEscalateToSupport();
                      }}
                      className="cursor-pointer hover:bg-green-50 font-semibold p-2 rounded-md flex gap-1 text-yellow-500"
                    >
                      <CircleCheckBig className="mr-2 h-4 w-4" />
                      Escalate to Support
                    </DropdownMenuItem>
                  </>
                )}
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </td>
      </tr>
      <OfferDetails
        open={modalApplicationData === "detail"}
        onClose={() => setModalApplicationData(null)}
        applicationId={applicationId}
        applicaitonData={applicaitonData}
      />
      {modal === "confirmAction" && (
        <ModelCommon
          close={() => setModal(null)}
          setModal={setModal}
          buttonText="Accept"
          title="Accept Offer"
          description="Are you sure you want to accept this offer?"
          onConfirm={handleAcceptOffer}
          className="bg-gradient-to-r from-green-50 to-emerald-50"
          buttonClassName="bg-gradient-to-r from-emerald-500 to-green-600 focus:ring-emerald-500"
          icon={<CircleCheck color="#059669" strokeWidth={2.25} size={24} />}
        />
      )}
      {modal === "rejectAction" && (
        <ModelCommon
          close={() => setModal(null)}
          buttonText="Reject"
          setModal={setModal}
          title="Reject Offer"
          titleClassname="text-red-500"
          description="Are you sure you want to reject this offer?"
          onConfirm={handleRejectOffer}
          className="bg-gradient-to-r from-red-50 to-red-100"
          buttonClassName="bg-gradient-to-r from-red-500 to-red-700 focus:ring-red-500"
          icon={<CircleX color="#ef4444" strokeWidth={2.25} size={24} />}
        />
      )}
    </>
  );
}
